<template>
  <div id="app" ref="app">
    <router-view />
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'App',
  data () {
    return {
      iconUrl: '',
      difference: '',
    }
  },

  mounted () {
    this.$nextTick(() => {
      const $app = this.$refs.app;
      // 设置 屏幕 百分比 尺寸 适配
      const standardScale = "100%" / "100%";

      window.addEventListener(
        "resize",
        _.debounce(function () {
          const docHeight = document.body.clientHeight;
          const docWidth = document.body.clientWidth;

          console.log(docWidth, '当前屏幕分辨率');

          if (docWidth < 1024 && docWidth > 768) {
            const currentScale = docHeight / docWidth;
            let [scale, translate] = [0, 0];
            if (currentScale < standardScale) {
              // 以高度计算
              scale = docHeight / 1080;
              const shouleWidth = 1920 * scale;

              const offsetWidth = docWidth - shouleWidth;
              translate =
                offsetWidth > 0 ? `translate(${offsetWidth / 2}px, 0)` : "";
            } else {
              // 以宽度计算
              scale = docWidth / 1920;
              const shouleHeight = 1080 * scale;
              const offsetHeight = docHeight - shouleHeight;
              translate =
                offsetHeight > 0 ? `translate(0, ${offsetHeight / 2}px)` : "";
            }
            console.log(translate);
            $app.style.cssText = `
            transform: scale(${scale}) ${translate};
            transform-origin: top left;
            min-width: 1920px;
            min-height: 1080px;
          `;
          } else {
            $app.style.cssText = "";
          }
        }),
        300
      );

      if (document.createEvent) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent("resize", true, true);
        window.dispatchEvent(event);
      } else if (document.createEventObject) {
        window.fireEvent("onresize");
      }
    });
  },

  methods: {
    getIcon () {
      this.$axios.get("/picture/selectAll").then((res) => {
        if (res.data.code === 200) {
          if (res.data.data !== null) {
            let iconUrl = res.data.data.iconUrl
            var link = document.head.querySelector("link[rel = 'icon']")
            link.href = iconUrl
          }
        }
      }).catch(() => { })
    },

    // 获取地址栏code
    getURLSearchParams () {
      // 获取查询字符串（不包括哈希部分）  
      const search = window.location.search;
      // 创建一个新的 URLSearchParams 对象  
      const params = new URLSearchParams(search);
      // 获取 code 参数的值  
      this.difference = params.get('code');
      window.localStorage.setItem('code', this.difference);
    },

  },

  created () {
    this.getURLSearchParams()
    let r1 = new Promise((resolve, reject) => {
      this.$axios.get("/picture/selectAll?tenantId=" + this.difference).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data !== null) {
            let iconUrl = res.data.data.iconUrl
            var link = document.head.querySelector("link[rel = 'icon']")
            link.href = iconUrl
            resolve();
          }
          else {
            reject();
          }
        }
      }).catch(() => {
        reject();
      })
    });
    let r2 = new Promise((resolve, reject) => {
      this.$axios.get("/picture/selectTitle?tenantId=" + this.difference).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data !== null) {
            this.$store.commit('setTitle', res.data.data.title);
            window.localStorage.setItem('systemName', res.data.data.abbreviation);
            resolve();
          }
          else {
            reject();
          }
        }
        else {
          reject();
        }
      }).catch(() => {
        reject();
      })
    });
    this.$nextTick(() => {
      Promise.all([r1, r2]).catch(() => {
        this.$message.error("初始化信息获取失败！");
      })
    })
    // this.getIcon()
  },

  computed: {
    title () {
      return this.$store.state.title;
    }
  },

  watch: {
    title: {
      handler (newVal, oldVal) {
        if (newVal) {
          document.head.querySelector('title').innerText = newVal;
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="less">
@import "commons/font/font.css";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

//.container{
//  display: flex;
//  flex-direction: row;
//  height: auto;
//  width: 100vw;
//}
/* 隐藏滚动条 */
//::-webkit-scrollbar{
//  width: 0;
//  height: 0;
//  color: transparent;
//}
/*修改滚动条样式*/
::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  /**/
}

::-webkit-scrollbar-track {
  opacity: 0;
  /*完全透明*/
  border-radius: 2px;
}

::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}
</style>
